export {default} from './App';



// WEBPACK FOOTER //
// ./components/App/index.ts